import type { ComponentProps, FC } from 'react';
import { TbStar, TbStarFilled } from 'react-icons/tb';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';

export interface FavoriteStatusIconProps extends ComponentProps<typeof TbStar> {
    favorited: boolean;
}

/** Shared visual treatment for favorite state across resource headers and feedback surfaces. */
const FavoriteStatusIcon: FC<FavoriteStatusIconProps> = ({ favorited, size = '1rem', style, ...props }) => {
    const { token } = useAntDesignTheme();
    const color = favorited ? token.gold5 : token.colorTextTertiary;
    const Icon = favorited ? TbStarFilled : TbStar;

    return (
        <Icon
            {...props}
            data-favorite-status={favorited ? 'favorited' : 'unfavorited'}
            size={size}
            style={{
                color,
                fill: favorited ? color : 'none',
                stroke: color,
                ...style,
            }}
        />
    );
};

export default FavoriteStatusIcon;
